import type {
  LimitOrderReferentialFormResponse,
  LimitOrderReloadFormRequest,
} from 'apiConnector/secondary-market/limit-order/models';
import type {
  SecondaryPostEventsLimitOrderPersistedTabContent,
  SecondaryQuotesLimitOrderFormPersistedTabContent,
} from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { LimitOrderForm } from 'state/secondaryMarket/limit-order/form/input/inputForm.model';
import { secondaryMarketInputFormActionsFactory } from 'state/secondaryMarket/shared/form/input/input.actions';

export const limitOrderInputFormActions = secondaryMarketInputFormActionsFactory<
  LimitOrderForm,
  'LIMIT_ORDER',
  LimitOrderReloadFormRequest,
  LimitOrderReferentialFormResponse,
  SecondaryQuotesLimitOrderFormPersistedTabContent | SecondaryPostEventsLimitOrderPersistedTabContent
>('LIMIT_ORDER');

export type LimitOrderInputFormActionsFunctions = typeof limitOrderInputFormActions;
export type SecondaryMarketLimitOrderLinkedToClientRequested = ReturnType<
  LimitOrderInputFormActionsFunctions['clientRequested']
>;
export type SecondaryMarketLimitOrderLinkedToClientReceived = ReturnType<
  LimitOrderInputFormActionsFunctions['clientReceived']
>;
export type SecondaryMarketLimitOrderLinkedToClientFailed = ReturnType<
  LimitOrderInputFormActionsFunctions['clientRequestFailed']
>;

export type SecondaryMarketLimitOrderReloadFormFetchRequested = ReturnType<
  LimitOrderInputFormActionsFunctions['reloadFormFetchRequested']
>;
export type SecondaryMarketLimitOrderReloadFormFetched = ReturnType<
  LimitOrderInputFormActionsFunctions['reloadFormFetched']
>;
export type SecondaryMarketLimitOrderReloadFormFetchedFailed = ReturnType<
  LimitOrderInputFormActionsFunctions['reloadFormFetchFailed']
>;

export type SecondaryMarketLimitOrderFormFieldChanged = ReturnType<
  LimitOrderInputFormActionsFunctions['formFieldChanged']
>;

export type SecondaryMarketLimitOrderTabContentPersistenceRequested = ReturnType<
  LimitOrderInputFormActionsFunctions['tabContentPersistenceRequested']
>;
export type SecondaryMarketLimitOrderTabContentPersisted = ReturnType<
  LimitOrderInputFormActionsFunctions['tabContentPersisted']
>;

export type SecondaryMarketLimitOrderLinkedToCustodianRequested = ReturnType<
  LimitOrderInputFormActionsFunctions['custodianRequested']
>;
export type SecondaryMarketLimitOrderLinkedToCustodianReceived = ReturnType<
  LimitOrderInputFormActionsFunctions['custodianReceived']
>;
export type SecondaryMarketLimitOrderLinkedToCustodianFailed = ReturnType<
  LimitOrderInputFormActionsFunctions['custodianRequestFailed']
>;

export type SecondaryMarketLimitOrderFormReset = ReturnType<LimitOrderInputFormActionsFunctions['resetForm']>;
export type SecondaryMarketLimitOrderInputFormActions = ReturnType<
  LimitOrderInputFormActionsFunctions[keyof LimitOrderInputFormActionsFunctions]
>;
